import type { Dispatch } from 'redux';

export const SET_MENU_ITEM_CART_LOCATION_ID = 'SET_MENU_ITEM_CART_LOCATION_ID';
export const SET_SELECTED_SECTION_INDEX = 'SET_SELECTED_SECTION_INDEX';
export const SET_SELECTED_SECTION_OFFSET = 'SET_SELECTED_SECTION_OFFSET';
export const SET_FOCUS_FIRST_SECTION_ITEM_EFFECT = 'SET_FOCUS_FIRST_SECTION_ITEM_EFFECT';
export const SET_SELECTED_SECTION_SLUG = 'SET_SELECTED_SECTION_SLUG';
export const SET_SHOULD_PRELOAD_SECTIONS = 'SET_SHOULD_PRELOAD_SECTIONS';

export type MenuItemCartAction =
  { type: typeof SET_MENU_ITEM_CART_LOCATION_ID, menuItemCartLocationId: Optional<number> } |
  { type: typeof SET_SELECTED_SECTION_INDEX, selectedSectionIndex: number } |
  { type: typeof SET_SELECTED_SECTION_OFFSET, selectedSectionOffset: number } |
  { type: typeof SET_SELECTED_SECTION_SLUG, selectedSectionSlug: Optional<string> } |
  { type: typeof SET_SHOULD_PRELOAD_SECTIONS, shouldPreloadSections: boolean } |
  { type: typeof SET_FOCUS_FIRST_SECTION_ITEM_EFFECT, status: 'active' | 'standby' }

// TODO: make this an alias for the argument type instead. Currently needed to decrease diff.
type DispatchMIC = (dispatch: Dispatch<MenuItemCartAction>) => void;

export function setMenuItemCartLocationId(menuItemCartLocationId: Optional<number>): DispatchMIC {
  return (dispatch) => {
    dispatch({ menuItemCartLocationId, type: SET_MENU_ITEM_CART_LOCATION_ID });
  };
}

export function setSelectedSectionIndex(selectedSectionIndex: number): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionIndex, type: SET_SELECTED_SECTION_INDEX });
  };
}

export function setSelectedSectionOffset(selectedSectionOffset: number): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionOffset, type: SET_SELECTED_SECTION_OFFSET });
  };
}

export function setFocusFirstSectionItemEffect(status: 'active' | 'standby'): DispatchMIC {
  return (dispatch) => {
    dispatch({ status, type: SET_FOCUS_FIRST_SECTION_ITEM_EFFECT });
  };
}

export function setSelectedSectionSlug(selectedSectionSlug: Optional<string>): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionSlug, type: SET_SELECTED_SECTION_SLUG });
  };
}

export function setShouldPreloadSections(shouldPreloadSections: boolean): DispatchMIC {
  return (dispatch) => {
    dispatch({ shouldPreloadSections, type: SET_SHOULD_PRELOAD_SECTIONS });
  };
}
